import { Component, OnInit } from '@angular/core';
import {RestApiService} from '../shared/restApiServices/restapi.service';
import { Router } from '@angular/router';
import {isUndefined} from "util";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-confirm-sign-up',
  templateUrl: './confirm-sign-up.component.html',
  styleUrls: ['./confirm-sign-up.component.css']
})
export class ConfirmSignUpComponent implements OnInit {

  confirmationCode:string;
  userName:string;
  userNameEmpty:string;
  confirmationCodeEmpty:string;
  isShowLoader = false;
  signUpFailMsg:string;
  signUpFail:boolean;
  userSubID:string;

  constructor(private restApiService:RestApiService,private router: Router,private route: ActivatedRoute) {
    this.signUpFail = false;
    this.signUpFailMsg = "";
  }

  ngOnInit() {
    // this.router.routerState.root.queryParams
    //   .subscribe(params => {
    //     console.log(params);
    //     // Defaults to 0 if no query param provided.
    //     this.userName  = params['userName'];
    //   });
    // this._activatedRoute.queryParams.subscribe(params => {
    //   console.log(params);
    //   let keys = Object.keys(params);
    //   if (keys.length > 0) {
    //     this.userName = params["userName"];
    //   }
    // });
    if( this.route.queryParams['_value']['userName'])
    {
      this.userName = this.route.queryParams['_value']['userName'];
    }
    if(this.route.queryParams['_value']['uID'])
    {
      this.userSubID = this.route.queryParams['_value']['uID'];
    }
  }

  confirmSignUpRequest()
  {
    if(this.userName==null || isUndefined(this.userName) || this.userName=="")
    {
      this.userNameEmpty = "on-error";
      this.confirmationCodeEmpty = "";
      return;
    }
    else if(this.confirmationCode==null || isUndefined(this.confirmationCode) || this.confirmationCode=="")
    {
      this.userNameEmpty = "";
      this.confirmationCodeEmpty = "on-error";
      return;
    }
    else {
      this.userNameEmpty = "";
      this.confirmationCodeEmpty = "";
      this.isShowLoader=true;

      this.restApiService.confirmSignUpService(this.userName, this.confirmationCode,'A').subscribe(
        result => {

          if(result.success)
          {
            //assign survey
            this.restApiService.assignSurveyOnSignUp(this.userSubID).subscribe(
              result => {
                this.isShowLoader = false;
                this.router.navigate(['/logIn'],{ queryParams: { email: this.userName} });
              }
            );
          }
          else {
            //signUp failed
            this.isShowLoader = false;
            this.signUpFailMsg = result.value;
            this.signUpFail = true;

          }

        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/confirm-sign-up/confirm-sign-up.component.ts